import React, { Component } from "react";
import AppForm from "../../partials/AppForm";
import AppInputFocus from "../../partials/AppInputFocus";

export class ConfigureAssessmentParameterSearch extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.state = {
      fields: [
        {
          name: "academic_year_id",
          type: "select",
          placeholder: "Academic Year",
          options: [{ key: "6a81c847aa55604d4d02bdc8", label: "2026-2027" }],
        },
        {
          name: "school_id",
          type: "select",
          placeholder: "School Name",
          options: props.schoolOptions || [],
        },
        {
          name: "parameters",
          type: "select",
          placeholder: "Parameters",
          options: [],
        }
      ],
    };
  }

  trimObjectValues(obj) {
    const trimmedObj = {};
    for (const key in obj) {
      if (typeof obj[key] === 'string') {
        trimmedObj[key] = obj[key].trim();
      } else {
        trimmedObj[key] = obj[key];
      }
    }
    return trimmedObj;
  }

  onSearch() {
    let data = this.refs.form.form.current.getData();
    data = this.trimObjectValues(data);
    data = Object.filter(data, (val) => val);
    this.props.onSearch && this.props.onSearch(data);
  }

  clearTextData = () => {
    this.setState({
      fields: this.state.fields.map(field => ({ ...field, value: '' }))
    });
    
    if (this.refs.form && this.refs.form.form.current) {
      this.refs.form.form.current.reset();
    }

    const clearedData = {};
    this.state.fields.forEach(f => {
      clearedData[f.name] = "";
    });
    
    this.props.onSearch && this.props.onSearch(clearedData);
  };

  handleInputChange = (i, event) => {
    const newFields = [...this.state.fields];
    if (newFields[i].type != "select") newFields[i].value = event.target.value;
    this.setState({ fields: newFields });
  };

  getSchoolNames = () => {
    const api = this.props.api || window.app?.api;
    if (!api) return;

    let currentAdminRole = localStorage.getItem("currentAdminRole");
    let fetchPromise;

    if (currentAdminRole === "SCHOOL_COORDINATOR" && api.apiGetAllSchoolListForCoordinator) {
      fetchPromise = api.apiGetAllSchoolListForCoordinator();
    } else if (api.apiGetSchoolList) {
      fetchPromise = api.apiGetSchoolList();
    } else if (api.apiGetAllSchoolListSuperAdmin) {
      fetchPromise = api.apiGetAllSchoolListSuperAdmin();
    }

    if (fetchPromise) {
      fetchPromise
        .then((res) => {
          let schools = [];
          if (res && res.data && Array.isArray(res.data) && res.data[0] && res.data[0].records) {
            schools = res.data[0].records;
          } else if (res && res.data && res.data.records) {
            schools = res.data.records;
          } else if (res && Array.isArray(res.data)) {
            schools = res.data;
          } else if (Array.isArray(res)) {
            schools = res;
          }

          let newFields = [...this.state.fields];
          let schoolField = newFields.find((f) => f.name === "school_id");
          if (schoolField) {
            schoolField.options = schools.map((s) => ({
              label: s.school_name,
              key: s.school_id,
              value: s.school_id,
              ...s,
            }));
          }
          this.setState({ fields: newFields });
        })
        .catch((err) => console.error("Failed to load school options", err));
    }
  };

  getAcademicYears = () => {
    const api = this.props.api || window.app?.api;
    if (api && api.apiGetAcademicYears) {
      api
        .apiGetAcademicYears()
        .then((res) => {
          let data = res?.data || res;
          let options = [];
          if (data?.options && typeof data.options === "function") {
            options = data.options("_id", "display_value");
          } else {
            let list = Array.isArray(data) ? data : (data?.records || data?.data || []);
            options = list.map((item) => ({
              key: item._id || item.id,
              label: item.display_value || item.academic_year || item.name,
              value: item._id || item.id,
            }));
          }
          const newFields = this.state.fields.map((f) => {
            if (f.name === "academic_year_id") {
              return { ...f, options };
            }
            return f;
          });
          this.setState({ fields: newFields });
        })
        .catch(() => { });
    }
  };

  updateParametersFromRecords = (records) => {
    if (!Array.isArray(records) || records.length === 0) return;
    const currentParamField = this.state.fields.find((f) => f.name === "parameters");
    const existingOptions = currentParamField?.options || [];
    
    const existingKeys = new Set(existingOptions.map((o) => o.key || o.name || o.value));
    const newOptions = [...existingOptions];
    
    records.forEach((rec) => {
      if (Array.isArray(rec.parameters)) {
        rec.parameters.forEach((p) => {
          const pName = p.name ? String(p.name).trim() : "";
          if (pName && !existingKeys.has(pName)) {
            existingKeys.add(pName);
            newOptions.push({
              key: pName,
              label: pName,
              value: pName,
              name: pName,
              ...p,
            });
          }
        });
      }
    });

    const newFields = this.state.fields.map((f) => {
      if (f.name === "parameters") {
        return { ...f, options: newOptions };
      }
      return f;
    });
    this.setState({ fields: newFields });
  };

  getParameters = () => {
    const api = this.props.api || window.app?.api;
    if (api && api.apiGetOfflineAssessmentParameters) {
      api
        .apiGetOfflineAssessmentParameters()
        .then((res) => {
          let list = [];
          if (Array.isArray(res)) {
            list = res;
          } else if (Array.isArray(res?.data)) {
            list = res.data;
          } else if (Array.isArray(res?.data?.items)) {
            list = res.data.items;
          } else if (Array.isArray(res?.data?.records)) {
            list = res.data.records;
          } else if (Array.isArray(res?.items)) {
            list = res.items;
          } else if (Array.isArray(res?.records)) {
            list = res.records;
          }
          let options = list.map((item) => {
            if (typeof item === "string") {
              return { key: item, label: item, value: item, name: item };
            }
            const keyVal = item.name || item._id || item.id || item.key;
            const labelVal = item.name || item.title || item.label || item.display_value || keyVal;
            return {
              key: keyVal,
              label: labelVal,
              value: keyVal,
              name: labelVal,
              ...item
            };
          });

          // Preserve any existing parameters already in options
          const currentParamField = this.state.fields.find((f) => f.name === "parameters");
          const existingOptions = currentParamField?.options || [];
          const optKeys = new Set(options.map((o) => o.key || o.name || o.value));

          existingOptions.forEach((eo) => {
            const eoKey = eo.key || eo.name || eo.value;
            if (eoKey && !optKeys.has(eoKey)) {
              optKeys.add(eoKey);
              options.push(eo);
            }
          });

          const newFields = this.state.fields.map((f) => {
            if (f.name === "parameters") {
              return { ...f, options };
            }
            return f;
          });
          this.setState({ fields: newFields });
        })
        .catch((err) => {
          console.error("Failed to load parameters in search filter", err);
        });
    }
  };

  componentDidMount() {
    if (this.props.schoolOptions && this.props.schoolOptions.length > 0) {
      let newFields = [...this.state.fields];
      let schoolField = newFields.find((f) => f.name === "school_id");
      if (schoolField) {
        schoolField.options = this.props.schoolOptions;
      }
      this.setState({ fields: newFields });
    } else {
      this.getSchoolNames();
    }
    this.getAcademicYears();
    this.getParameters();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.schoolOptions !== prevProps.schoolOptions &&
      Array.isArray(this.props.schoolOptions) &&
      this.props.schoolOptions.length > 0
    ) {
      let newFields = [...this.state.fields];
      let schoolField = newFields.find((f) => f.name === "school_id");
      if (schoolField) {
        schoolField.options = this.props.schoolOptions;
      }
      this.setState({ fields: newFields });
    }

    let schoolField = this.state.fields.find((f) => f.name === "school_id");
    if (
      this.props.api !== prevProps.api &&
      (!schoolField?.options || schoolField.options.length === 0)
    ) {
      this.getSchoolNames();
      this.getAcademicYears();
      this.getParameters();
    }
  }

  render() {
    let { fields } = this.state;

    return (
      <AppForm className="row filter-row" ref="form">
        {fields.map((field, i) => (
          <div className="col-sm-6 col-md-3" key={i}>
            <AppInputFocus
              {...field}
              onChange={(event) => this.handleInputChange(i, event)}
            ></AppInputFocus>
          </div>
        ))}
        <div className="col-sm-6 col-md-3">
          <button
            className="btn btn-success btn-block w-100"
            onClick={() => this.onSearch()}
          >
            Search
          </button>
        </div>
        <span className="clear-all" onClick={() => this.clearTextData()}>
          Clear All
        </span>
      </AppForm>
    );
  }
}

export default ConfigureAssessmentParameterSearch;
